import { render, staticRenderFns } from "./UserContractAlert.vue?vue&type=template&id=70f60ac8&"
import script from "./UserContractAlert.vue?vue&type=script&lang=js&"
export * from "./UserContractAlert.vue?vue&type=script&lang=js&"
import style0 from "./UserContractAlert.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAlert } from 'vuetify/lib/components/VAlert';
installComponents(component, {VAlert})
